export default {
      id: "icon--fitness-usage",
      viewBox: "0 0 30.8 30.9",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--fitness-usage",
      toString: function () {
        return this.url;
      }
    }